import { atom } from 'recoil'

type MenuParentOpenAtomType = string

export const menuParentOpenAtom = atom<MenuParentOpenAtomType>({
  key: 'menuParentOpenState',
  default: '',
})
